var map = {
	"./bg/strings.json": 1967,
	"./cs/strings.json": 1968,
	"./da/strings.json": 1969,
	"./de/strings.json": 1970,
	"./el/strings.json": 1971,
	"./es-ES/strings.json": 1972,
	"./es-LA/strings.json": 1973,
	"./et/strings.json": 1974,
	"./fi/strings.json": 1975,
	"./fr-CA/strings.json": 1976,
	"./fr/strings.json": 1977,
	"./it/strings.json": 1978,
	"./lt/strings.json": 1979,
	"./lv/strings.json": 1980,
	"./nl/strings.json": 1981,
	"./no/strings.json": 1982,
	"./pl/strings.json": 1983,
	"./pseudo/strings.json": 1984,
	"./pt/strings.json": 1985,
	"./ro/strings.json": 1986,
	"./sk/strings.json": 1987,
	"./sl/strings.json": 1988,
	"./sv/strings.json": 1989,
	"./zh-CN/strings.json": 1990,
	"./zh-TW/strings.json": 1991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1966;